import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { take } from "rxjs/operators";
import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import SortOptions from "../../models/content-wrapper/sort-options";
import NoteAuthor from "../../models/patient-chart/notes/author";
import PatientNote from "../../models/patient-chart/notes/note";
import NoteLookups from "../../models/patient-chart/notes/noteLookups";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class NotesServiceProvider {
  notesUrl: string;

  notes: PatientNote[];
  changeNotes: Subject<PatientNote[]> = new Subject<PatientNote[]>();

  hospiceTotalPageCount: number = 0;
  pageLimit: number = 7;
  hospiceCurrentPage = 0;
  hospicePageLimit: number = 10;
  HospiceCurrentPage: number = 0;
  sortEncounterOptions: SortOptions = new SortOptions(
    "updatedDatetime",
    "desc"
  );

  toDate: Date = null;
  fromDate: Date = null;
  patientChartId: any;
  totalElements: number = 0;

  maxStartDate: any;
  minEndDate: any;

  constructor(
    public http: HttpClient,
    private toastCtrl: ToastController,
    private config: ConfigurationService
  ) {
    this.notesUrl = config.getConfig().notesUrl;

    this.changeNotes.subscribe((notes: PatientNote[]) => {
      this.notes = notes;
    });
  }

  /* Returns the distinct list of authors for this patient chart */
  authors(patientChartId: number): Observable<NoteAuthor[]> {
    return this.http.get<NoteAuthor[]>(
      `${this.notesUrl}/patient-charts/${patientChartId}/notes/authors`
    );
  }

  /* Returns the lookup values for notes */
  lookupValues(): Observable<NoteLookups> {
    return this.http.get<NoteLookups>(`${this.notesUrl}/notes/lookups`);
  }

  getNotes(
    patientChartId: number,
    page = 0,
    size = 10,
    orderBy = "createdDatetime",
    sortBy = "desc",
    options = "",
    noteType: string = "",
    fromDate: Date = null,
    toDate: Date = null
  ): Observable<ContentWrapper<PatientNote>> {
    if (fromDate && toDate) {
      return this.http
        .get<ContentWrapper<PatientNote>>(
          `${
            this.notesUrl
          }/patient-charts/${patientChartId}/notes?page=${page}&note-type=${noteType}&limit=${size}&by=${sortBy}&direction=${orderBy}&from-date=${this.formatDate(
            this.fromDate
          )}&to-date=${this.formatDate(this.toDate)}&${options}`
        )
        .pipe(take(1));
    }
    return this.http
      .get<ContentWrapper<PatientNote>>(
        `${this.notesUrl}/patient-charts/${patientChartId}/notes?page=${page}&note-type=${noteType}&limit=${size}&by=${sortBy}&direction=${orderBy}&${options}`
      )
      .pipe(take(1));
  }

  updateNotes(notes: PatientNote[]) {
    this.changeNotes.next(notes);
  }

  public formatDate(date: any) {
    return date + "Z";
  }

  public clearFilter() {
    this.fromDate = null;
    this.toDate = null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/notesService.ts